<template>
  <form>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <form-group
          label="Full Name"
          input-type="text"
          :validator-object="$v.form.full_name"
        ></form-group>
      </div>
      <div class="md-layout-item md-size-100">
        <form-group
          label="Email Address"
          input-type="email"
          :validator-object="$v.form.email"
        ></form-group>
      </div>
      <div class="md-layout-item md-size-100">
        <form-group
          label="Mobile Number"
          input-type="tel"
          :validator-object="$v.form.mobile"
        ></form-group>
      </div>
      <div class="md-layout-item md-size-100">
        <form-group
          label="Which business do you work for?"
          input-type="text"
          :validator-object="$v.form.business"
        ></form-group>
      </div>
      <div class="md-layout-item md-size-100 d-flex align-items-center">
        <md-button
          class="md-primary mt-3"
          :disabled="loading"
          @click="submit()"
        >
          Continue
        </md-button>
        <md-progress-spinner
          class="mx-3"
          :md-diameter="30"
          :md-stroke="loading ? 4 : 0"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>
    </div>
  </form>
</template>
<script>
import ApiService from "@/services/api";
import userModel from "@/models/user";
import FormGroup from "@/components/Forms/FormGroup";
import { email, required } from "vuelidate/lib/validators";
import { toastLaravelErrors } from "@/mixins";

export default {
  name: "ParkingPassForm",
  components: { FormGroup },
  mixins: [toastLaravelErrors],
  data() {
    return {
      form: {
        full_name: "",
        email: "",
        mobile: "",
        business: ""
      },
      loading: false
    };
  },
  validations: {
    form: {
      full_name: {
        required
      },
      email: {
        required,
        email
      },
      mobile: {
        required
      },
      business: {
        required
      }
    }
  },
  created() {
    ApiService.auth.setCSRF();
  },
  methods: {
    submit() {
      if (!this.validate()) return;

      this.loading = true;

      ApiService.parkingPass
        .submit(this.form)
        .then(() => {
          window.location.href =
            "https://primepark.com.au/location/sydney-markets";
        })
        .catch(error => {
          this.toastLaravelErrors(error);

          this.$toast.error(
            error.response?.data.message ||
              "Sorry an error occurred. Please check your information and try again."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  }
};
</script>
<style></style>
